/* src/app/modules_v2/booking/locations/components/sections/location-service-section/location-service-dialog.component.css */
.service-dialog {
  width: 100%;
  max-width: 800px;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  margin: -24px -24px 0 -24px;
}
.dialog-header h2 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.dialog-header h2 mat-icon {
  color: #666;
}
.close-button {
  margin-right: -12px;
}
mat-dialog-content,
.mat-mdc-dialog-content {
  padding: 24px !important;
  max-height: 70vh;
  overflow-y: auto;
}
.service-form {
  width: 100%;
}
.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}
.form-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #555;
  margin-bottom: 20px;
}
.section-title mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #666;
}
.w-100 {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
.col-md-6,
.col-md-12 {
  padding: 0 10px;
  margin-bottom: 15px;
}
.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.staff-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 12px;
  background: #fff3cd;
  border-left: 3px solid #ffc107;
  border-radius: 4px;
  font-size: 13px;
  color: #856404;
}
.warning-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #ffc107;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 24px !important;
  margin: 0 -24px -24px -24px;
  border-top: 1px solid #e0e0e0;
  gap: 10px;
}
@media (max-width: 768px) {
  .service-dialog {
    max-width: 100%;
  }
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .dialog-header {
    padding: 16px 20px;
  }
  mat-dialog-content,
  .mat-mdc-dialog-content {
    padding: 20px !important;
  }
  mat-dialog-actions,
  .mat-mdc-dialog-actions {
    flex-direction: column-reverse;
  }
  mat-dialog-actions app-button,
  .mat-mdc-dialog-actions app-button {
    width: 100%;
  }
}
/*# sourceMappingURL=location-service-dialog.component.css.map */
